import { useAppSelector } from '../../hooks/redux'
import { Navigate, useLocation } from 'react-router-dom'

const PrivateRoute = ({ children }: { children: any }) => {
  const { user: currentUser } = useAppSelector((state) => state.user)
  const location = useLocation()

    if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }
  return children
}

export default PrivateRoute
